import { Link } from "react-router-dom";
import { FileWarning, PackagePlus } from "lucide-react";
import { useI18n } from "@/i18n";

export const SellPage = () => {
  const { t } = useI18n();
  return (
    <div className="mx-auto max-w-2xl px-4 py-24 text-center" data-testid="sell-page">
      <PackagePlus className="mx-auto h-12 w-12 text-[#FF7A6B]" />
      <h1 className="mt-5 text-3xl font-bold sm:text-4xl">{t("sell.title")}</h1>
      <p className="mt-3 text-[#64748B]">{t("sell.text")}</p>
      <Link to="/cerca" className="btn-violet mt-8" data-testid="sell-browse-btn">{t("sell.back")}</Link>
    </div>
  );
};

export const LegalPage = () => {
  const { t } = useI18n();
  return (
    <div className="mx-auto max-w-3xl px-4 py-16" data-testid="legal-page">
      <h1 className="text-3xl font-bold sm:text-4xl">{t("legal.title")}</h1>
      <p className="mt-4 flex items-center gap-2 rounded-xl bg-[#FFF0EE] px-4 py-3 text-sm font-semibold text-[#E0533F]"><FileWarning className="h-4 w-4" />{t("legal.draft")}</p>
      <ul className="mt-6 space-y-3">{t("legal.items").map((i) => <li key={i} className="card-soft px-5 py-4 font-semibold">{i}</li>)}</ul>
    </div>
  );
};

export const HowPage = () => {
  const { t } = useI18n();
  return (
    <div className="mx-auto max-w-5xl px-4 py-16" data-testid="how-page">
      <h1 className="text-4xl font-bold sm:text-5xl">{t("nav.how")}</h1>
      <div className="mt-10 grid gap-5 sm:grid-cols-2">
        {["outlet", "market", "scambi", "pro"].map((k) => (
          <div key={k} className="card-soft p-6"><h3 className="text-xl font-bold text-[#3B1272]">{t(`areas.${k}.t`)}</h3><p className="mt-2 text-[#64748B]">{t(`areas.${k}.d`)}</p></div>
        ))}
      </div>
      <div className="card-soft mt-5 p-6"><h3 className="text-xl font-bold">{t("home.coinTitle")}</h3><p className="mt-2 text-[#64748B]">{t("home.coinText")}</p><p className="mt-2 font-semibold text-amber-700">{t("home.coinExample")}</p><p className="mt-2 text-xs text-[#94A3B8]">{t("home.coinNote")}</p></div>
    </div>
  );
};
